/* eslint-disable react/jsx-filename-extension */
import { AuthProvider } from './src/hooks/useAuth';
import React from 'react';

export const wrapRootElement = ({ element }) => (
	<AuthProvider>{element}</AuthProvider>
);
